import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { captureUtmParams } from '../utils/utm';

/**
 * Fires a page_view on every route change. MUST be used inside <Router>.
 * Captures first-touch UTM before the pageview so it is attached from the
 * very first navigation (captureUtmParams is idempotent — first-touch only).
 */
const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    captureUtmParams();
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};

export default usePageTracking;
